import type { User } from '@graphql/types'

type Track = (
  eventName: string,
  eventProperties?: Record<string, unknown>,
  user?: Pick<User, 'optedInToAnalytics'>
) => void

const track: Track = (eventName, eventProperties = {}, user = null) => {
  if (import.meta.env.MODE === 'development') {
    console.log('Segment Analytics (stub):', eventName, eventProperties) // eslint-disable-line no-console

    return
  }

  if (typeof analytics === 'undefined') {
    return
  }

  if (user && !user.optedInToAnalytics) {
    return
  }

  analytics.track(eventName, eventProperties)
}

export default track
